
{
  "fr": {
    "label": "Supprimer le compte",
    "confirm": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible."
  }
}
